import {
  CloudCpuPlatformServiceData,
  CloudInstanceTypeServiceData,
  CloudProviderServiceData,
  DcLocationServiceData,
} from 'services/GameHosting/Cloud/cloudServiceType';
import { FetchAction } from 'types/services/redux-action';
import { FetchReducer } from 'types/services/redux-state';

export const FETCH_DC_LOCATION = 'FETCH_DC_LOCATION';

export const FETCH_DC_LOCATION_IS_PENDING = 'FETCH_DC_LOCATION_IS_PENDING';

export const FETCH_DC_LOCATION_IS_ERROR = 'FETCH_DC_LOCATION_IS_ERROR';

export const FETCH_DC_LOCATION_BY_ID = 'FETCH_DC_LOCATION_BY_ID';

export const FETCH_DC_LOCATION_BY_ID_IS_PENDING = 'FETCH_DC_LOCATION_BY_ID_IS_PENDING';

export const FETCH_DC_LOCATION_BY_ID_IS_ERROR = 'FETCH_DC_LOCATION_BY_ID_IS_ERROR';

export const FETCH_PROVIDERS_DETAILS = 'FETCH_PROVIDERS_DETAILS';

export const FETCH_PROVIDERS_DETAILS_IS_PENDING = 'FETCH_PROVIDERS_DETAILS_IS_PENDING';

export const FETCH_PROVIDERS_DETAILS_IS_ERROR = 'FETCH_PROVIDERS_DETAILS_IS_ERROR';

export const FETCH_INSTANCE_TYPES = 'FETCH_INSTANCE_TYPES';

export const FETCH_INSTANCE_TYPES_IS_PENDING = 'FETCH_INSTANCE_TYPES_IS_PENDING';

export const FETCH_INSTANCE_TYPES_IS_ERROR = 'FETCH_INSTANCE_TYPES_IS_ERROR';

export const FETCH_CLOUD_IMAGES = 'FETCH_CLOUD_IMAGES';

export const FETCH_CLOUD_IMAGES_IS_PENDING = 'FETCH_CLOUD_IMAGES_IS_PENDING';

export const FETCH_CLOUD_IMAGES_IS_ERROR = 'FETCH_CLOUD_IMAGES_IS_ERROR';

export const FETCH_CPU_PLATFORM = 'FETCH_CPU_PLATFORM';

export const FETCH_CPU_PLATFORM_IS_PENDING = 'FETCH_CPU_PLATFORM_IS_PENDING';

export const FETCH_CPU_PLATFORM_IS_ERROR = 'FETCH_CPU_PLATFORM_IS_ERROR';

export const RESET_REDUCER = 'RESET_CLOUD_REDUCER';

export type CloudReducerState = {
  dcLocations: DcLocationServiceData[];
  providers: CloudProviderServiceData[];
  instances: CloudInstanceTypeServiceData[];
  cpuPlatforms: CloudCpuPlatformServiceData[];
  dcLocationById: DcLocationServiceData | undefined;
} & FetchReducer<'fetchDcLocations' | 'fetchProvidersDetails' | 'fetchInstanceTypes' | 'fetchCpuPlatform' | 'fetchDcLocationsById'>;

export type CloudActions =
  | FetchAction<'FETCH_DC_LOCATION', DcLocationServiceData[]>
  | FetchAction<'FETCH_DC_LOCATION_BY_ID', DcLocationServiceData>
  | FetchAction<'FETCH_PROVIDERS_DETAILS', CloudProviderServiceData[]>
  | FetchAction<'FETCH_INSTANCE_TYPES', CloudInstanceTypeServiceData[]>
  | FetchAction<'FETCH_CPU_PLATFORM', CloudCpuPlatformServiceData[]>
  | { type: 'CLEAN_ERROR' };
